import { render, staticRenderFns } from "./spot.vue?vue&type=template&id=1f083949&scoped=true&"
import script from "./spot.vue?vue&type=script&lang=js&"
export * from "./spot.vue?vue&type=script&lang=js&"
import style0 from "./spot.vue?vue&type=style&index=0&id=1f083949&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f083949",
  null
  
)

export default component.exports